// extracted by mini-css-extract-plugin
module.exports = {"header":"ForgotPasswordModal__header___3S7ek","description":"ForgotPasswordModal__description___Oo_DB","spacer":"ForgotPasswordModal__spacer___3ZlI_"};